"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scripts
require("./props-filter");
exports.default = angular.module('profumo.core.filters', [
    'profumo.core.filters.props-filter',
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/filters/index.ts
// module id = 466
// module chunks = 0